import { Box, Container, Typography } from '@mui/material';

import DashboardHero from '../components/Dashboard/DashboardHero.tsx';
import SavedSearches from '../components/Dashboard/SavedSearches/SavedSearches.tsx';

function Dashboard() {
  return (
    <Container
      sx={{
        marginY: '1em',
        background: '#FFF',
        borderRadius: '8px',
        border: '1px solid #CBD5E0',
        paddingX: '0px !important',
      }}
    >
      <DashboardHero />
      <Box component='div' sx={{ maxWidth: '1080px', margin: '0 auto' }} id='tour-saved-searches-section'>
        <div style={{ margin: '28px 0' }}>
          <Typography variant='h6' sx={{ marginBottom: '24px', fontWeight: 600 }}>
            Saved Searches
          </Typography>
        </div>
        <SavedSearches />
      </Box>
    </Container>
  );
}

export default Dashboard;
